module.exports = __webpack_public_path__ + "img/downarrow.cee5462a.svg";